import * as React from "react";
import { DestinationNearestProps } from "./typings";
import { DestinationNearestFlexModuleResult } from "typings/microserviceModels/destination-nearest-flex-module";
import { UitkHeading } from "uitk-react-text";
import CardsView from "components/shared/DestinationCardView/CardsView";
import ListsView from "components/shared/DestinationCardView/ListsView";
import { getFormatTextLocationKey } from "components/flexComponents/DestinationNearest/DestinationNearestUtils";
import { ViewType } from "components/flexComponents/DestinationNearest/DestinationNearestEnums";
import { withStores } from "src/stores";
import { observer } from "mobx-react";

export const DestinationNearest = withStores(
  "flexModuleModelStore",
  "context"
)(
  observer((props: DestinationNearestProps) => {
    const { flexTemplateNode, flexModuleModelStore, context } = props;
    const { id } = flexTemplateNode;
    const model = flexModuleModelStore.getModel(id) as DestinationNearestFlexModuleResult | null;
    const destinations = model?.destinations;

    if (!model || !destinations || !destinations.length) {
      return null;
    }

    const { title, view, geoType } = model;

    return (
      <div className="DestinationNearest uitk-cell all-cell-1-1" id={id} data-testid="DestinationNearestHeading">
        <div className="all-b-margin-three">
          <UitkHeading level={2} size={600}>
            {title}
          </UitkHeading>
        </div>

        {view === ViewType.DETAIL ? (
          <CardsView
            baseKey="destination-nearest-cards"
            context={context}
            destinations={destinations}
            localiseKey={getFormatTextLocationKey(geoType)}
            moduleName="destinationNearest"
          />
        ) : (
          <ListsView
            baseKey="destination-nearest-links"
            destinations={destinations}
            localiseKey={getFormatTextLocationKey(geoType)}
            moduleName="destinationNearest"
          />
        )}
      </div>
    );
  })
);

export default DestinationNearest;
